import { getSetting } from '@woocommerce/settings';
import Fields from './fields';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { debounce } from 'lodash';

const cfeSettings = getSetting('thwcfe-block-integration_data', '');
const { allSections } = cfeSettings;
const { contact } = allSections;

const Block = ( { checkoutExtensionData, extensions } ) => {

    const { setExtensionData } = checkoutExtensionData;
	const [sectionValues, setSectionValues] = useState({});

    const debouncedSetExtensionData = useCallback(
        
        debounce( ( values ) => {
			setExtensionData( `thwcfe-additional-fields`, 'contact' ,values );
		}, 1000 ),
		[ setExtensionData ]
    );
    useEffect(() => {
        if (Object.keys(sectionValues).length > 0) {
            debouncedSetExtensionData(sectionValues);
        }
        return () => {
            debouncedSetExtensionData.cancel();
        };
    }, [sectionValues, debouncedSetExtensionData]);

	const onChangeSection = useCallback((fieldValues) => {
        setSectionValues(prevValues => ({
            ...prevValues,
            ...fieldValues
        }));
    }, []);

    const fields = Array.isArray(contact.fields)
    ? contact.fields
    : Object.values(contact.fields);

    return (
        <div >
            {fields.map((field) => {
                return (
                    <div key={field.id} className="wc-block-checkout__additional-fields__field">
                        <Fields
                            field={{ ...field, value: sectionValues[field.id] || '' }}  
                            onChange={onChangeSection} 

                        />
                    </div>
                );
                
			})}
                
        </div>
    );
};
export default  Block

